import { createSSRApp as n } from "vue";
import { renderToString as o } from "vue/server-renderer";
async function i(r, e) {
  const t = n(r, e);
  return await o(t);
}
export {
  i as renderVueElement
};
